var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('div',{staticClass:"messages-wrapper",class:'message-' + _vm.type},[_c('div',{staticClass:"message-content",class:{'closable': _vm.close}},[_c('p',[_vm._v(_vm._s(_vm.message))])]),(_vm.close)?_c('div',{staticClass:"message-close",on:{"click":_vm.Hide}}):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }